import React, { useEffect } from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import Nav from "../components/Nav";
import disableBrowserBackButton from 'disable-browser-back-navigation';

const CounselorThankyou = () => {
    useEffect(() => {
        document.title = 'Thank You | Families of WWII Vetearnas';
        window.scrollTo({ top: 0, behaviour: "smooth" })
        disableBrowserBackButton();
    }, [])
    return (
        <React.Fragment>
            <section className='counselorThankYouContainer '>
                <div>
                    <Header title="Scholarship Applications" />
                    <div className="container py-3 py-md-4 py-md-5">
                        <div className="row">
                            <div className="col-12">
                                <Nav navbType="" />
                                <div >
                                    <h2>Thank you for your support. </h2>
                                    <p className="lead">Thank you for your submission and supporting your student's scholarship application.</p>
                                    <p> The recipients of our 2023 scholarships will be announced late July or early August.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </section>
        </React.Fragment>
    );
}

export default CounselorThankyou;